import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

export default {
    name: 'BestRatedProfilesReport',
    data,
    methods,
    mounted,
    watch
}
